import { gsap, ScrollTrigger } from "@gsap";
/**
 * Layout: Committee overview
 * Slug: committee_overview
 */

document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollTrigger);
	const layouts = document.querySelectorAll('.flex-layout.committee_overview-layout');

	layouts.forEach((layout) => {
		gsap.from(layout.querySelectorAll('.speaker-item'), {
			y: -20,
			autoAlpha: 0,
			stagger: 0.1,
			scrollTrigger: {
				trigger: layout.querySelector('.member-row'),
				start: 'top center+=25%',
				markers: false,
			},
		});
	});
});
